export default ({app, store}) => {
  app.wp = app.i18n.locale === 'en'
    ? `https://selectel.ru/en/wp-json/wp`
    : 'https://selectel.ru/wp-json/wp'

  app.i18n.onLanguageSwitched = () => {
    app.wp = app.i18n.locale === 'en'
      ? `https://selectel.ru/en/wp-json/wp`
      : 'https://selectel.ru/wp-json/wp'

    if (store.getters['rest-client/servers/services/getAllServices'].length) {
      store.dispatch('rest-client/servers/services/fetchServices')
    }
  }
}